import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/slices/authSlice';
import classes from './Layout.module.css';

const Layout = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const streakDays = useSelector(state => state.auth.streakDays);
    const user = useSelector(state => state.auth.user);

    const handleLogout = () => {
        dispatch(logout());
        navigate('/');
    };

    const navItems = [
        { path: '/dashboard', label: 'Home', icon: '🏠', description: 'Overview & insights' },
        { path: '/insights', label: 'Insights', icon: '📊', description: 'Financial analytics' },
        { path: '/learn', label: 'Learn', icon: '🎓', description: 'Education hub' },
        { path: '/connections', label: 'Connections', icon: '🔧', description: 'Account management' }
    ];

    const getPageTitle = () => {
        const currentItem = navItems.find(item => item.path === location.pathname);
        return currentItem ? currentItem.label : 'Dashboard';
    };

    return (
        <div className={classes.layout}>
            <header className={classes.header}>
                <div className={classes.headerContent}>
                    <div className={classes.headerLeft}>
                        <div className={classes.logoSection}>
                            <h1 className={classes.logo}>Cent Capital</h1>
                            <p className={classes.logoTagline}>Make sense of your cents</p>
                        </div>

                        <nav className={classes.nav}>
                            {navItems.map(item => (
                                <button
                                    key={item.path}
                                    className={`${classes.navItem} ${location.pathname === item.path ? classes.active : ''}`}
                                    onClick={() => navigate(item.path)}
                                >
                                    <div className={classes.navItemContent}>
                                        <span className={classes.navIcon}>{item.icon}</span>
                                        <div className={classes.navText}>
                                            <span className={classes.navLabel}>{item.label}</span>
                                            <span className={classes.navDescription}>{item.description}</span>
                                        </div>
                                    </div>
                                    {location.pathname === item.path && (
                                        <div className={classes.activeIndicator}></div>
                                    )}
                                </button>
                            ))}
                        </nav>
                    </div>

                    <div className={classes.headerRight}>
                        {/* Streak Display */}
                        <div className={classes.streak}>
                            <div className={classes.streakContent}>
                                <span className={classes.streakIcon}>🔥</span>
                                <div className={classes.streakInfo}>
                                    <span className={classes.streakCount}>{streakDays}</span>
                                    <span className={classes.streakLabel}>day streak</span>
                                </div>
                            </div>
                        </div>

                        {/* Notifications */}
                        {/* <div className={classes.notifications}>
                            <button className={classes.notificationBtn}>
                                <span className={classes.notificationIcon}>🔔</span>
                                <div className={classes.notificationBadge}>3</div>
                            </button>
                        </div> */}

                        {/* User Menu */}
                        <div className={classes.userMenu}>
                            <div className={classes.userInfo}>
                                <div className={classes.userDetails}>
                                    <span className={classes.userName}>{user?.firstName || 'User'}</span>
                                    <span className={classes.userEmail}>{user?.email || 'user@example.com'}</span>
                                </div>
                                <div className={classes.profileIcon}>
                                    <span>{(user?.firstName || 'U').charAt(0).toUpperCase()}</span>
                                </div>
                            </div>
                        </div>

                        {/* Logout Button */}
                        <button className={classes.logoutBtn} onClick={handleLogout}>
                            <span className={classes.logoutIcon}>🚪</span>
                            <span className={classes.logoutText}>Logout</span>
                        </button>
                    </div>
                </div>
            </header>

            {/* Page Breadcrumb */}
            <div className={classes.breadcrumb}>
                <div className={classes.breadcrumbContent}>
                    <div className={classes.breadcrumbPath}>
                        <span className={classes.breadcrumbHome}>Home</span>
                        <span className={classes.breadcrumbSeparator}>→</span>
                        <span className={classes.breadcrumbCurrent}>{getPageTitle()}</span>
                    </div>
                    {/* 
                    <div className={classes.pageActions}>
                        <button className={classes.quickAction}>
                            <span className={classes.quickActionIcon}>📊</span>
                            <span>Quick Report</span>
                        </button>
                        <button className={classes.quickAction}>
                            <span className={classes.quickActionIcon}>⚙️</span>
                            <span>Settings</span>
                        </button>
                    </div> */}
                </div>
            </div>

            <main className={classes.main}>
                <div className={classes.mainContent}>
                    {children}
                </div>

                {/* Floating Action Button */}
                <div className={classes.fab}>
                    <button className={classes.fabButton}>
                        <span className={classes.fabIcon}>💬</span>
                    </button>
                    <div className={classes.fabTooltip}>Need help? Chat with AI</div>
                </div>
            </main>

            {/* Footer */}
            <footer className={classes.footer}>
                <div className={classes.footerContent}>
                    <div className={classes.footerLeft}>
                        <p className={classes.footerText}>
                            © 2025 Cent Capital. Your financial co-pilot.
                        </p>
                    </div>
                    <div className={classes.footerRight}>
                        <div className={classes.footerStats}>
                            <div className={classes.footerStat}>
                                <span className={classes.footerStatValue}>256</span>
                                <span className={classes.footerStatLabel}>Active Users</span>
                            </div>
                            <div className={classes.footerStat}>
                                <span className={classes.footerStatValue}>$2.4M</span>
                                <span className={classes.footerStatLabel}>Tracked</span>
                            </div>
                            <div className={classes.footerStat}>
                                <span className={classes.footerStatValue}>99.9%</span>
                                <span className={classes.footerStatLabel}>Uptime</span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Layout;